"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _HightRiskChartComponent = _interopRequireDefault(require("../../HightRiskChart/HightRiskChartComponent"));
var _numberFormatter = require("../../../helpers/numberFormatter");
require("../../../styles/components/TradeComponent.css");
require("./MarginOverviewComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('margin-overview');
var getRiskClassCss = function getRiskClassCss(risk) {
  if (risk === 0) {
    return 'verylow';
  } else if (risk === 1) {
    return 'low';
  } else if (risk === 2) {
    return 'medium';
  } else if (risk === 3) {
    return 'high';
  } else if (risk === 4 || risk === 5 || risk === 6) {
    return 'veryhigh';
  }
};
var MarginOverviewComponent = function MarginOverviewComponent(_ref) {
  var t = _ref.t,
    baseCurrency = _ref.baseCurrency,
    baseCurrencyDecimalPlaces = _ref.baseCurrencyDecimalPlaces,
    _ref$showTitle = _ref.showTitle,
    showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
    fetching = _ref.fetching,
    summary = _ref.summary,
    riskLevelNumber = _ref.riskLevelNumber,
    _ref$riskLevel = _ref.riskLevel,
    riskLevel = _ref$riskLevel === void 0 ? 5 : _ref$riskLevel,
    riskLabel = _ref.riskLabel;
  var renderProductItem = (0, _react.useCallback)(function (name, value) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('item')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('item-name')
    }, t(name)), /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('item-value')
    }, value));
  }, [t]);
  var riskLevelCell = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(baseClasses('risk-level', getRiskClassCss(riskLevel)))
    }, /*#__PURE__*/_react["default"].createElement(_HightRiskChartComponent["default"], {
      level: riskLevel,
      size: "small"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('risk-label')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('risk-value')
    }, riskLevelNumber), "\xA0", t(riskLabel).toUpperCase()));
  }, [riskLevelNumber, riskLevel, riskLabel, t]);
  if (fetching) {
    return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
  }
  var formatValue = function formatValue(value) {
    return isNaN(value) || value === undefined ? value : (0, _numberFormatter.formatNumberToLocale)(value, baseCurrencyDecimalPlaces);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(tradeComponentClasses(), baseClasses())
  }, showTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: tradeComponentClasses('header')
  }, t('Margin Overview')), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(tradeComponentClasses('body'), baseClasses('body'))
  }, renderProductItem('Risk Level (0-100)', riskLevelCell), renderProductItem(t('Usable Margin ({{asset}})', {
    asset: baseCurrency
  }), "".concat(formatValue(summary.UsableMarginValue))), renderProductItem(t('Maintenance Threshold ({{asset}})', {
    asset: baseCurrency
  }), "".concat(formatValue(summary.MaintenanceRequirement))), renderProductItem(t('Margin Equity ({{asset}})', {
    asset: baseCurrency
  }), "".concat(formatValue(summary.MarginEquity))), renderProductItem(t('Liability ({{asset}})', {
    asset: baseCurrency
  }), formatValue(summary.Liability)), renderProductItem(t("Today's P&L ({{asset}})", {
    asset: baseCurrency
  }), "".concat(formatValue(summary.PnLValue), " (").concat((0, _numberFormatter.formatNumberToLocale)(summary.PnLPercentage, 2), "%)")), renderProductItem(t('Total Balance ({{asset}})', {
    asset: baseCurrency
  }), formatValue(summary.Balance))));
};
MarginOverviewComponent.propTypes = {
  showTitle: _propTypes["default"].bool,
  fetching: _propTypes["default"].bool.isRequired,
  summary: _propTypes["default"].shape({
    Balance: _propTypes["default"].number.isRequired,
    MarginBalance: _propTypes["default"].number.isRequired,
    Liability: _propTypes["default"].number.isRequired
  }),
  baseCurrency: _propTypes["default"].string.isRequired,
  riskLevel: _propTypes["default"].number.isRequired,
  usableMarginNotional: _propTypes["default"].number.isRequired,
  baseCurrencyDecimalPlaces: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('margin')(MarginOverviewComponent);